import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from "./en/Footer";
import CoverPage from "./en/CoverPage";
import ReportService from "../services/ReportService";
import { useLocation } from 'react-router-dom';
import {getQueryParams} from "../services/UtilityService";
import ProgressOverview from "./en/ProgressOverview";
import ProgressFinalThoughts from "./en/ProgressFinalThoughts";
import ProgressStatements from "./en/ProgressStatements";
import ProgressResultComparison from "./en/ProgressResultComparison";
import ITPAssessmentsService from "../services/ITPAssessmentsService";

const ITPProgressReport = () => {
    const location = useLocation();
    const params = getQueryParams(location.search);

    const reportData = ITPAssessmentsService.getReportData(params);
    let assessment = {};

    if(reportData){
        const assessmentResults = reportData.results.find(r => r.ASSESSMENT)?.ASSESSMENT;
        const progressResults = reportData.results.find(r => r.PROGRESS)?.PROGRESS;

        const initialAssessmentQuestions = reportData.questionsByCategory.find(r => r.ASSESSMENT)?.ASSESSMENT;
        const currentAssessmentQuestions = reportData.questionsByCategory.find(r => r.PROGRESS)?.PROGRESS;

        const initialAssessmentSorted = {
            [assessmentResults?.rank3]:  Math.min(5, assessmentResults?.rank3Score),   // SMART: 2.2
            [assessmentResults?.rank2]:  Math.min(5, assessmentResults?.rank2Score),   // HUNGRY: 3
            [assessmentResults?.rank1]:  Math.min(5, assessmentResults?.rank1Score),  // HUMBLE: 4.6
        };

        const progressAssessmentSorted = {
            [progressResults?.rank1]:   Math.min(5, progressResults?.rank1Score),   // SMART: 2.2
            [progressResults?.rank2]:  Math.min(5, progressResults?.rank2Score),    // HUNGRY: 3
            [progressResults?.rank3]:  Math.min(5, progressResults?.rank3Score),     // HUMBLE: 4.6
        };

        console.log({
            initialAssessmentQuestions,
            currentAssessmentQuestions,
        })
        const initialDate = Object.keys(initialAssessmentQuestions)?.[0];
        const currentDate = Object.keys(currentAssessmentQuestions)?.[0];
        const initialQuestions = initialAssessmentQuestions?.[initialDate];
        const currentQuestions = currentAssessmentQuestions?.[currentDate];

        const questionsByCategory = Object.entries(currentQuestions)?.reduce((acc, [category, questions]) => {
            acc[category] = Object.keys(questions)?.map(label => {
                const currentScoring = questions[label];
                const initialScoring = initialQuestions[category][label];

                return {
                    label,
                    initial: initialScoring,
                    current: currentScoring
                }
            });
            return acc;
        }, {});
        assessment = {
            name: `${reportData?.firstName} ${reportData?.lastName}`,
            firstName: reportData?.firstName,
            initialAssessmentSorted: Object.entries(initialAssessmentSorted),
            progressAssessmentSorted: Object.entries(progressAssessmentSorted),
            assessmentResults,
            progressResults,
            initialAssessmentQuestions,
            currentAssessmentQuestions,
            questionsByCategory: {
                [assessmentResults?.rank3]: questionsByCategory?.[assessmentResults?.rank3],
                [assessmentResults?.rank2]: questionsByCategory?.[assessmentResults?.rank2],
                [assessmentResults?.rank1]: questionsByCategory?.[assessmentResults?.rank1]
            },
            initialDate,
            currentDate,
        };
    }

    const renderQuestionComparison = (assessment) => {
        const categoryScoring = assessment?.questionsByCategory;
        return Object.entries(categoryScoring).map((categoryQuestions, index) => {
            const category = categoryQuestions?.[0];
            const statements = categoryQuestions?.[1];
            const description = ReportService.ITPProgressStatementComparison?.[index]?.describe(category);
            return (
                <section role='region' className='Page'>
                    <ProgressStatements
                        key={`${category?.toString()?.toUpperCase()}ProgressStatements`}
                        assessment={assessment}
                        currentDate={assessment?.currentDate}
                        initialDate={assessment?.initialDate}
                        category={category?.toString()?.toUpperCase()}
                        statements={statements}
                        description={description}
                    />
                    <Footer page={index+3} />
                </section>
            )
        });
    }
    const renderContent = () => {
       return (
           <div id={'itp-assessment-report'} className={'itp-pdf-assessment-report'}>
               <section role='region' className='Page CoverPage'>
                   <CoverPage type={'PROGRESS'} assessment={assessment}/>
               </section>
               <section role='region' className='Page'>
                   <ProgressOverview />
                   <Footer page={1} />
               </section>
               <section role='region' className='Page'>
                   <ProgressResultComparison assessment={assessment} />
                   <Footer page={2} />
               </section>
               {renderQuestionComparison(assessment)}
               <section role='region' className='Page'>
                   <ProgressFinalThoughts />
                   <Footer page={6} />
               </section>
           </div>
       )
    };

    return (
        <>
            <Helmet>
                <meta charSet='UTF-8' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                <meta httpEquiv='X-UA-Compatible' content='ie=edge' />
                <link rel='stylesheet' href='/report/pdf.css' />
                <title>The Ideal Team Player Progress  Assessment Report</title>
            </Helmet>
            {renderContent()}
        </>
    );
};

export default ITPProgressReport;
